import React, { useContext } from 'react';
import { IsValidEmail } from '../../../../utils/Validators';
import { ThemeContext } from 'styled-components';
import { Button } from '@mui/material';
import InputValidatorField from "./InputValidatorField";

const InputEmail = ({
    email,
    onEmailChange,
    disabled = false,
    showValidation = true,
    onKeyPress
}) => {
    const theme = useContext(ThemeContext);

    // Check if email is invalid (has content but is not valid)
    const emailValue = email || '';
    const hasContent = Boolean(emailValue && emailValue.length > 0);
    const isValid = Boolean(IsValidEmail(emailValue));
    const isInvalid = hasContent && !isValid;

    return (
        <InputValidatorField
            label="Email"
            type="email"
            name="email"
            value={emailValue}
            autoComplete="email"
            disabled={disabled}
            handleChange={onEmailChange}
            onKeyPress={onKeyPress}
            isValidInput={IsValidEmail}
            tooltipEnabled={false}
            InputLabelProps={{
                style: { color: disabled ? theme.colors.textDisabled : theme.colors.text },
            }}
            InputProps={{
                style: { color: disabled ? theme.colors.textDisabled : theme.colors.text },
            }}
        />
    );
};

export default InputEmail;
